import React, { memo, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Grid, Box } from '@mui/material'
import { Surface } from '../components'
import PaginationFooter from './PaginationFooter'
import { initialPage, initialPageSize } from './Pagination.hooks'
import { PaginationProps } from './Pagination.types'

function Pagination(props: PaginationProps) {
    const location = useLocation()
    const query = useMemo(
        () => new URLSearchParams(location.search),
        [location]
    )

    const { children, onChangedPageSize } = props

    const page = initialPage(query)
    const pageSize = initialPageSize(query)
    const variant = useMemo(() => props.variant, [props])

    useEffect(() => {
        onChangedPageSize(page, pageSize)
    }, [page, pageSize, onChangedPageSize])

    if (variant === 'embeded') {
        return (
            <Grid container>
                <Grid item xs={12}>
                    {children}
                </Grid>
                <Grid item xs={12}>
                    <Box pl={2}>
                        <PaginationFooter query={query} {...props} />
                    </Box>
                </Grid>
            </Grid>
        )
    }

    return (
        <Surface
            footerActions={<PaginationFooter query={query} {...props} />}
            {...props}
        >
            {children}
        </Surface>
    )
}

export default memo(Pagination)
